import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  transform-style: preserve-3d;
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    transform: none !important;
    transition: none !important;
  }
`;
